import React from "react";
import { IOnGoingTrip } from "@types";
import { formatDateBrUtc } from "@utils";
import moment from "moment";

interface PublicInfoProps {
  detail?: IOnGoingTrip | null;
  currencyAddress?: string;
  showTimes?: boolean;
  showCoordinates?: boolean;
}

export const PublicInfo: React.FC<PublicInfoProps> = ({ detail, currencyAddress, showTimes = true, showCoordinates = true }) => (
  <>
    {detail?.latLongActually && (
      <>
        <div className="padding-y-16 padding-x-15">
          <span>Ultima Posição identificada</span>
          <br />
          <span className="text-normal text-size-16">{currencyAddress}</span>
        </div>

        {showCoordinates && (
          <div className="display-flex padding-y-15 padding-x-15">
            <div className="display-flex align-items-center gap-4">
              <span className="rioglyph rioglyph-map-marker text-size-18 text-color-primary"></span>
              <span className="text-normal text-size-16">
                {detail.latLongActually.lat}, {detail.latLongActually.lng}
              </span>
            </div>
          </div>
        )}
      </>
    )}

    {showTimes && (
      <div className="display-flex padding-y-15 padding-x-15">
        <div className="width-50pct">
          <span>Horário de saida</span>
          <br />
          <span className="text-normal text-size-16">
            {detail?.departure ? formatDateBrUtc(detail.departure) : '-'}
          </span>
        </div>
        <div className="width-50pct">
          <span>Previsão de chegada</span>
          <br />
          <span className="text-normal text-size-16">
            {detail?.eta
              ? formatDateBrUtc(moment(detail.eta, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss'))
              : '-'}
          </span>
        </div>
      </div>
    )}
  </>
);